<template>
  <a-modal
    :title="null"
    :visible="visible"
    :footer="null"
    @cancel="handleCancel"
  >
    <a-tabs default-active-key="1">
      <a-tab-pane key="1" tab="注册新账号">
        <div v-if="!isSuccess" class=" pt-20">
          <a-form-model ref="form" :model="form1" layout="horizontal" :rules="loginRules1" :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-form-model-item prop="mobilePhone" label="手机号">
              <a-input v-model="form1.mobilePhone" :disabled="disabled" placeholder="手机号码" />
            </a-form-model-item>
            <a-form-model-item prop="validateCode" label="验证码">
              <a-input v-model="form1.validateCode" type="验证码" placeholder="验证码">
                <CountDown slot="suffix" :count="60" @start="countDown" />
              </a-input>
            </a-form-model-item>
            <!-- <div class="t-center mb-22">—————————— 以下为企业信息 ——————————</div>
            <a-form-model-item prop="companyName" label="企业名称">
              <a-input v-model="form1.companyName" placeholder="请输入企业名称或个体姓名" />
            </a-form-model-item>
            <a-form-model-item prop="linkMan" label="管理员名称">
              <a-input v-model="form1.linkMan" placeholder="请输入企业的指定服务联络人" />
            </a-form-model-item>
            <a-form-model-item prop="userName" label="公司账号名">
              <a-input v-model="form1.userName" placeholder="请输入4位以上的字母或数字组合" />
            </a-form-model-item> -->
            <a-form-model-item prop="userPassword" label="登录密码">
              <a-input v-model="form1.userPassword" type="password" placeholder="请设置登录密码" />
            </a-form-model-item>
            <a-form-model-item prop="aginPassword" label="确认密码">
              <a-input v-model="form1.aginPassword" type="password" placeholder="请设置确认密码" />
            </a-form-model-item>
            <a-form-model-item class="flex-center">
              <a-button
                class="w-100p m-center"
                type="primary"
                :loading="formLoading"
                @click="postForm1"
              >
                注 册
              </a-button>
            </a-form-model-item>
          </a-form-model>
          <div class="t-center">已有账号，<span class="pointer f-c-blue" @click="toLogin">马上登录</span></div>
          <div class="t-center mt-10">注册代表你已同意<span class="pointer f-c-blue" @click="$userAgreement.display()">《用户协议》</span></div>
        </div>

        <div v-else class="pt-20 t-center">
          <div class="">
            <a-icon class="f-c-green fs-70" theme="filled" type="check-circle" />
          </div>
          <div class="mt-25 fs-20 fs-b f-c-b">
            恭喜 {{ mobile }}（用户名：{{ userName }}）
          </div>
          <div class="mt-10 mb-20 fs-16 f-c-b2">
            注册成功 , {{ timeCount }} 秒后返回首页
          </div>
          <div class="pb-30">
            <a-button class="w-300 m-center" type="primary" @click="toHome">
              返回首页
            </a-button>
          </div>
        </div>
      </a-tab-pane>

    </a-tabs>
  </a-modal>
</template>
<script>
import CountDown from '../CountDown'
import { getToken, setToken } from '@framework/utils/auth' // get token from cookie
import validate from '@framework/utils/biz-validate'
export default {
  components: {
    CountDown
  },
  data() {
    const _this = this
    const validateMobile = (rule, value, callback) => {
      if (!validate.mobile.pattern.test(value)) {
        callback(new Error(validate.mobile.msg))
      } else {
        callback()
      }
    }
    const validateUsername = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入正确的用户名'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('密码最少需要6位'))
      } else {
        callback()
      }
    }
    const validateAginPassword = (rule, value, callback) => {
      console.log(value, _this.form1.userPassword)
      if (value.length < 6) {
        callback(new Error('密码最少需要6位'))
      } else if (value !== _this.form1.userPassword) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    return {
      aginPassword: '',
      mobile: '',
      userName: '',
      timeCount: 3,
      disabled: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 12 },
      loginRules1: {
        userName: [
          { required: true, trigger: 'blur', validator: validateUsername }
        ],
        mobilePhone: [
          { required: true, trigger: 'blur', validator: validateMobile }
        ],
        userPassword: [
          { required: true, trigger: 'blur', validator: validatePassword }
        ],
        aginPassword: [
          { required: true, trigger: 'blur', validator: validateAginPassword }
        ],
        companyName: [
          { required: true, trigger: 'blur', message: '请输入企业名称' }
        ],
        linkMan: [
          { required: true, trigger: 'blur', message: '请输入联系人姓名' }
        ],
        validateCode: [
          { required: true, trigger: 'blur', message: '请输入验证码' }
        ]
      },
      visible: false,
      confirmLoading: false,
      form1: {
        'companyName': '',
        'linkMan': '',
        'mobilePhone': '',
        'userName': '',
        'userPassword': '',
        'validateCode': '',
        aginPassword: ''
      },
      formLoading: false,
      jump: '',
      isSuccess: false
    }
  },

  methods: {
    toHome() {
      window.location.href = '/#/main/index'
    },
    async countDown(count) {
      this.$refs.form.validateField('mobilePhone', async(err) => {
        if (!err) {
          const res = await this.$http({ ...this.$api.registerGetValidateCode, origin: true }, {
            mobilePhone: this.form1.mobilePhone,
            smstype: 0
          })
          if (res.data.state === 'success') {
            count.next()
          } else {
            this.$message.error(res.data.msg)
          }
        }
      })
    },
    close() {
      this.jump = ''
      Object.assign(this.form1, {
        'companyName': '',
        'linkMan': '',
        'mobilePhone': '',
        'userName': '',
        'userPassword': '',
        'validateCode': ''
      })
      this.disabled = false
      this.visible = false
    },
    show(path) {
      this.jump = path
      this.visible = true
    },
    toLogin() {
      this.visible = false
      this.$login.show()
    },
    regSuccess() {
      this.isSuccess = true
      this.timeCount = 3
      const timer = setInterval(() => {
        this.timeCount--
        if (this.timeCount === 0) {
          if (this.jump) {
            window.location.href = this.jump
          } else {
            window.location.reload()
          }
          this.timeCount = 3
          this.isSuccess = false
          this.formLoading = false
          this.close()
          clearInterval(timer)
        }
      }, 1000)
    },
    postForm1() {
      this.$refs.form.validate(async v => {
        if (v) {
          this.formLoading = true
          try {
            const data = Object.assign({}, this.form1)
            delete data.aginPassword
            const res = await this.$http(this.$api.registerRegister, { ...data, disableCheckPhoneCode: 1 })
            if (res) {
              // Object.assign(this.form1, {
              //   'companyName': '',
              //   'linkMan': '',
              //   'mobilePhone': '',
              //   'userName': '',
              //   'userPassword': '',
              //   'validateCode': ''
              // })
              // this.$message.success('注册成功')
              // this.$login.show()
              setToken(res.token)
              this.mobile = res.mobile
              this.userName = res.userName
              this.regSuccess()
              // this.isSuccess = true
              // this.timeCount = 3
              // let timer  = setInterval(() => {
              //   this.timeCount--
              //   if(this.timeCount == 0){
              //     if (this.jump) {
              //       window.location.href = this.jump
              //     } else {
              //       window.location.reload()
              //     }
              //     this.timeCount = 3
              //     this.isSuccess = false
              //     this.formLoading = false
              //     this.close()
              //   }
              // }, 1000)
              // window.location.reload()
            }
            // setToken(res)
            // window.location.reload()
          } catch (error) {
            this.formLoading = false
          }
        }
      })
    },
    handleCancel(e) {
      this.close()
    }
  }
}
</script>
